import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";

import { Provider } from "react-redux";
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import roofReducer from "./Features/roofInfo";
import panelReducer from "./Features/panelInfo";
import statusReducer from "./Features/statusInfo";
import projectImageReducer from "./Features/projectImage";
import gridViewReducer from "./Features/gridViewInfo";
import inverterReducer from "./Features/inverterInformation";
import quantityReducer from "./Features/quantityInfo";
// import userInfoReducer from "./Features/userInfo";
// import structureReducer from "./Features/structureInfo";
// import irredianceReducer from "./Features/irrediance";
// import reportAdditionsReducer from "./Features/reportAdditions";
// import sessionTimeOutReducer from "./Features/session";

// New Reducer
import userReducer from "./reducer/user.reducer";
import reportInfoReducer from "./reducer/reportInfo.reducer";

// import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import reportFeaturesReducer from "./Features/reportFeatures";
import designParameterReducer from "./Features/designParameter";
// import  variablesReducer  from "./Features/customVariables";

const persistConfig = {
  key: "root",
  storage: storageSession,
};

const rootReducer = combineReducers({
  roof: roofReducer,
  panel: panelReducer,
  status: statusReducer,
  
  img: projectImageReducer,
  grid: gridViewReducer,
 
  inverter: inverterReducer,
  quantity: quantityReducer,
  // user: userInfoReducer,
   // irradiance: irredianceReducer,
  // sessionTimeOut: sessionTimeOutReducer,
  reportFeatures: reportFeaturesReducer,
  designParameter: designParameterReducer,

  conUser: userReducer,
  reportInfo: reportInfoReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);
